import React, { useContext, useEffect } from 'react';
import { ColorContext } from 'App';

export default function DeviceCustomInput({ onChange, value, dataMapItem }) {
  const theme = useContext(ColorContext);
  const { type, units, values } = dataMapItem || {};

  useEffect(() => {
    if (value === null || value === undefined) {
      switch (type) {
        case 'float':
          onChange(0.0);
          break;
        case 'bool':
          onChange(false);
          break;
        default:
          onChange(null);
          break;
      }
    }
  }, [type]);

  if (type === 'float') {
    return (
      <div className="d-flex align-items-center gap-2 w-100">
        <input
          className="bg-base p-1 rounded-1 w-100"
          type="number"
          step="any"
          inputMode="decimal"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
        />
        {units ? <div className="text-body-secondary">{units}</div> : null}
      </div>
    );
  }

  if (type === 'bool') {
    // Keep DOM values as strings; coerce to boolean on change
    const current = value === true ? 'true' : 'false';
    const trueLabel = values?.['true'] ?? 'True';
    const falseLabel = values?.['false'] ?? 'False';

    return (
      <select
        className="bg-base p-1 w-100"
        value={current}
        onChange={(e) => onChange(e.target.value === 'true')}
      >
        <option value="true">{trueLabel}</option>
        <option value="false">{falseLabel}</option>
      </select>
    );
  }

  return null;
}
